import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import creditCardIcon from './assets/CardIcon';
import './StripeFieldWrapper.scss';

class StripeFieldWrapper extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    label: PropTypes.string,
    isFocused: PropTypes.bool.isRequired,
    isEmpty: PropTypes.bool.isRequired,
    isComplete: PropTypes.bool.isRequired,
    isError: PropTypes.string.isRequired,
  }

  static defaultProps = {
    className: '',
    label: '',
  }

  state = {}

  render() {
    const {
      className,
      children,
      label,
      isFocused,
      isEmpty,
      isError,
      isComplete,
    } = this.props;
    const stripeFieldClasses = classNames({
      'stripe-field-wrapper': true,
      'show-float-label': isFocused || !isEmpty,
      'text-field-failed': isError,
      'is-complete': isComplete,
      'is-focused': isFocused,
      [`${className}`]: true,
    });

    return (
      <div className={stripeFieldClasses}>
        <div className="text-field-float-label">
          <span>{label}</span>
        </div>
        {creditCardIcon}
        {children}
        <div className="text-field-error-text">
          <span>{isError}</span>
        </div>
      </div>
    );
  }
}

export default StripeFieldWrapper;



// WEBPACK FOOTER //
// ./src/components/StripeCard/components/StripeFieldWrapper/StripeFieldWrapper.js